import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { pathname } from "@react/helpers/fetch"
import Modal  from "@react/shared/ui/Modal"
import Button from "@react/shared/ui/Button"
import Input  from "@react/shared/ui/Input"
import ClientSitePicker from "./ClientSitePicker"
import ManagerAutocomplete from "./ManagerAutocomplete"

const defaultManagerId = (managers, currentUserId) =>
  managers.some(manager => String(manager.id) === String(currentUserId)) ? currentUserId : ""

const NewQuoteModal = ({ isOpen, onClose, newQuoteUrl, managers = [], currentUserId }) => {
  const [title,  setTitle]  = useState("")
  const [client, setClient] = useState(null)
  const [site,   setSite]   = useState(null)
  const [managerId, setManagerId] = useState(() => defaultManagerId(managers, currentUserId))

  useEffect(() => {
    if (!isOpen) return
    setTitle("")
    setClient(null)
    setSite(null)
    setManagerId(defaultManagerId(managers, currentUserId))
  }, [isOpen])

  const canSubmit = title.trim() && client && site && managerId

  const handleConfirm = () => {
    if (!canSubmit) return
    window.location.href = pathname({
      path:   newQuoteUrl,
      params: {
        "quote[title]":      title.trim(),
        "quote[client_id]":  client.id,
        "quote[site_id]":    site.id,
        "quote[manager_id]": managerId,
      },
    })
  }

  return (
    <Modal
      isOpen  = {isOpen}
      onClose = {onClose}
      size    = "lg"
      title   = {I18n.t("quotes.project_index.new_quote")}
      footer  = {
        <>
          <Button variant="ghost" onClick={onClose}>{I18n.t("button.cancel")}</Button>
          <Button variant="primary" onClick={handleConfirm} disabled={!canSubmit}>
            <FontAwesomeIcon icon="plus" />
            {I18n.t("button.create")}
          </Button>
        </>
      }
    >
      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-slate-700">
          {I18n.t("quotes.project_index.table.title")}
        </label>
        <Input value={title} onChange={e => setTitle(e.target.value)} />
      </div>

      <ClientSitePicker
        client         = {client}
        site           = {site}
        onClientChange = {setClient}
        onSiteChange   = {setSite}
      />

      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-slate-700">
          {I18n.t("quotes.builder.settings.manager_label")}
        </label>
        <ManagerAutocomplete managers={managers} value={managerId} onChange={setManagerId} />
      </div>
    </Modal>
  )
}

export default NewQuoteModal
